import { mapState } from 'vuex';

const mixin = {
  computed: {
    ...mapState({
      menuAtivoSidebar: (state) => state.layout.menuAtivo,
    }),
  },
  methods: {
    $abrirFuncao({ url, tipo }, menu, params = {}, query = {}) {
      const { codigo, uid } = menu;

      if (codigo !== this.menuAtivoSidebar || menu.descricao !== sessionStorage.getItem('MENU_DESCRICAO')) {
        this.$store.commit('layout/setMenuAtivo', menu);
      }

      this.$router.push({
        [this.$lg.config.modoAberturaRota]: url || this.$lg.config.rotaPadrao,
        query: {
          id: codigo,
          uid,
          tipo,
          ...query,
        },
        params,
      }).catch(() => { /* ignore se houver erro de duplicidade */ });
    },
  },
};

export default mixin;
